<!-- @format -->

<div class="modal-header">
  <button class="modal-close" (click)="close()" type="button" [attr.aria-label]="'ARIA_LABEL.CLOSE' | translate">
    <sis-icon icon="ring-close"></sis-icon>
  </button>
  <h2 class="modal-title" translate>PROFILE.STUDY_PATH.PERSONALIZED_SELECTION_RATIONALE</h2>
</div>
<div class="modal-body">
  @if (phase1) {
    <div class="form-group-mimic">
      @if (phase1.name) {
        <h4 translate>{{ phase1.name | localizedString }}</h4>
      }
      @if (phase1.description) {
        <p>{{ phase1.description }}</p>
      }
    </div>
  }
  @if (phase2) {
    <div class="form-group-mimic">
      @if (phase2.name) {
        <h4 translate>{{ phase2.name | localizedString }}</h4>
      }
      @if (phase2.description) {
        <p>{{ phase2.description }}</p>
      }
    </div>
  }
</div>
